module.exports = "<slot></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/FormGroup.vue
// module id = 134
// module chunks = 0